import { useState } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom"
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'
import icon_2 from '../../images/icones/slider/erkennen.png'
import icon_3 from '../../images/icones/slider/aufnehmen.png'
import icon_4 from '../../images/icones/slider/senden.png'
import icon_5 from '../../images/icones/slider/labor.png'

import image from '../../images/symptoms/C_mahpin_iNaturalist.png'

function Mitmachen() {

  return (

    <Container className="bggreen">

      <Grid container flexDirection="row" className="p-6">

        <Grid size={{ xs: 12, sm: 12, md: 10 }}>

          <Title text="mitmachen_title" variant="big" color="orange" />

          <ul className="list-disc white">
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_1">
              </Text>
            </li>
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_2">
              </Text>
            </li>
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_3">
              </Text>
            </li>
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_4_1">
              </Text>
              <Link to="/report">
                <Text
                  variant="normal"
                  color="beige"
                  text="point_4_2">
                </Text>
              </Link>
              <Text
                variant="normal"
                color="beige"
                text="point_4_3">
              </Text>
            </li>
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_5">
              </Text>
            </li>
            <li className="py-1">
              <Text
                variant="normal"
                color="beige"
                text="point_6">
              </Text>
            </li>
          </ul>

          <div className="pt-4">
            <Text variant="white_bold" text="base_line" color="beige"></Text>
          </div>

        </Grid>

        <Grid
          container
          size={{ xs: 12, sm: 12, md: 2 }}
          flexDirection={"column"}
          justifyContent={"center"}>
          <img src={image} />
        </Grid>

      </Grid>

      {/* 
      <Grid container flexDirection="row" justifyContent="space-evenly" spacing={0}>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>

          <Grid className="border-2">
            <div className="logo">
              <img src={icon_1} className="iconlogo"></img>
            </div>
          </Grid>

          <Grid className="border-2">
            <Title text="iconrow_nr1_text" variant="title_green"></Title>
          </Grid>

          <Grid className="center">
            <Title text="iconrow_nr1_verb" variant="title_light"></Title>
          </Grid>

        </Grid>

      </Grid>
      */}

    </Container>
  );
}

export default Mitmachen;
